// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"e832172f","55":"466fbda8","126":"70156930","171":"9ffcc301","594":"ccb2bd0d","780":"b05be7f6","994":"97afed66"}[chunkId] + ".chunk.js";
};